module.exports = __webpack_public_path__ + "static/img/hb_50-min.0aed471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_50-min.png
// module id = AKSI
// module chunks = 1